import React, { createContext, useEffect, useState } from "react"
import axios from "axios"
import LocalStorageService from "../_services/localstorageservice"
import jwt from "jsonwebtoken"
import jwt_decode from "jwt-decode"

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
    const storedUser = JSON.parse(window.localStorage.getItem("sims_storedUser"))
    const [currentUser, setCurrentUser] = useState(storedUser)

    const [token, setToken] = useState(localStorage.getItem("access_token"))
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    let authService = LocalStorageService.getService()

    useEffect(() => {
        window.localStorage.setItem("sims_storedUser", JSON.stringify(currentUser))
        if (currentUser) {
            authService.setToken(currentUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])

    useEffect(() => {
        if (token) {
            try {
                const decodedToken = jwt_decode(token)
                const currentTime = Date.now() / 1000

                if (decodedToken.exp < currentTime) {
                    // Token has expired
                    // console.log("token expired-----", decodedToken)
                    handleLogout()
                } else {
                    setIsAuthenticated(true)

                    // console.log("token valid-----", decodedToken)
                    // Set up automatic logout when token expires
                    const timeUntilExpiry = (decodedToken.exp - currentTime) * 1000
                    setTimeout(handleLogout, timeUntilExpiry)
                }
            } catch (error) {
                // console.log("error----")
                handleLogout()
            }
        }
    }, [token])

    const fetchToken = () => {
        const currentUser = JSON.parse(window.localStorage.getItem("sims_storedUser"))
        if (!currentUser) return null
        const { accessToken } = currentUser
        return accessToken
    }

    // const isAuthenticated = () => {
    //     const secretKey = process.env.REACT_APP_TOKEN_SECRET

    //     const currentUser = JSON.parse(window.localStorage.getItem("sims_storedUser"))
    //     if (!currentUser) return null
    //     const { accessToken } = currentUser
    //     // console.log(accessToken)
    //     let authStatus = false
    //     jwt.verify(accessToken, secretKey, (err, decoded) => {
    //         // console.log(err)
    //         if (err) {
    //             authStatus = false
    //         } else {
    //             authStatus = true
    //             // setValidJWT(true)
    //         }
    //     })
    //     return authStatus
    // }

    const sendInvite = async (data) => {
        // try {
        return await axios
            .post(process.env.REACT_APP_API_SERVER + "auth/sendinvite", {
                requester_id: data.requester_id,
                requester_email: data.requester_email,
                invited_email: data.invited_email,
                invited_accesslvl: data.invited_accesslvl,
            })
            .then((res) => {
                console.log(res.data)

                return res
            })
        // } catch (err) {
        //   return err
        // };
    }

    const confirmInvite = async (data) => {
        // try {
        return await axios
            .post(process.env.REACT_APP_API_SERVER + "auth/acceptinvite", {
                user_email: data.email,
                user_password: data.password,
                user_name: data.name,
            })
            .then((res) => {
                console.log(res.data)

                return res
            })
        // } catch (err) {
        //   return err
        // };
    }

    const loginUser = async (data) => {
        // try {
        return await axios
            .post(process.env.REACT_APP_API_SERVER + "auth/signin", {
                user_email: data.email,
                user_password: data.password,
            })
            .then((res) => {
                console.log(res.data)
                if (res.data.user) {
                    const {
                        user_id,
                        user_name,
                        user_email,
                        user_role,
                        user_roleid,
                        accessToken,
                    } = res.data.user
                    setCurrentUser({
                        user_id,
                        user_name,
                        user_email,
                        user_role,
                        user_roleid,
                        accessToken,
                    })
                }

                return res
            })
        // } catch (err) {
        //   return err
        // };
    }

    const updatePassword = async (data) => {
        try {
            return await axios
                .post(process.env.REACT_APP_API_SERVER + "auth/changepassword", {
                    user_email: data.user_email,
                    user_password: data.password,
                })
                .then((res) => {
                    console.log(res.data)

                    return res.data
                })
        } catch (err) {
            return err
        }
    }

    const updatePermissions = async (data) => {
        try {
            return await axios
                .post(process.env.REACT_APP_API_SERVER + "auth/changepermissions", {
                    user_email: data.email,
                    user_permissionlvl: data.access_level,
                })
                .then((res) => {
                    console.log(res.data)

                    return res
                })
        } catch (err) {
            return err
        }
    }

    const forgotPassword = async (data) => {
        try {
            return await axios
                .post(process.env.REACT_APP_API_SERVER + "auth/forgotpassword", {
                    email: data.email,
                })
                .then((res) => {
                    console.log(res.data)

                    return res
                })
        } catch (err) {
            return err
        }
    }

    const logoutUser = (history, authStatus) => {
        console.log("logout user")
        setCurrentUser(null)
        // history.push('/login');
        // if (history) {
        //     history.push({
        //         pathname: "/login",
        //         state: { message: authStatus },
        //     })
        // }
    }

    const handleLogout = () => {
        localStorage.removeItem("access_token")
        setToken(null)
        setCurrentUser(null)
        setIsAuthenticated(false)
    }

    return (
        <AuthContext.Provider
            value={{
                currentUser,
                sendInvite,
                confirmInvite,
                updatePermissions,
                isAuthenticated,
                setCurrentUser,
                loginUser,
                updatePassword,
                forgotPassword,
                fetchToken,
                logoutUser,
            }}
        >
            {typeof currentUser === "undefined" ? (
                <div className="h-screen w-full flex items-center justify-center">
                    <div>
                        <i className="fas fa-spin fa-3x" />
                        <p>Loading....</p>
                    </div>
                </div>
            ) : (
                children
            )}
        </AuthContext.Provider>
    )
}
